import { defineMessages } from "react-intl";

export const SelectLinkedRecordModalText = defineMessages({
  searchPlaceholder: {
    defaultMessage: "No matching records",
    id: "qfLxmQ",
  },
});
